module.exports = __webpack_public_path__ + "img/lb.d1f16074.svg";